import React, { useEffect, useState } from 'react';
import styled from "styled-components";
const OuterContainer = styled.div.withConfig({
  displayName: "PopupAutoScaleContainer__OuterContainer",
  componentId: "sc-5sr3ar-0"
})(["overflow:hidden;"]);
const InnerContainer = styled.div.withConfig({
  displayName: "PopupAutoScaleContainer__InnerContainer",
  componentId: "sc-5sr3ar-1"
})(["display:block;position:relative;width:", "px;height:", "px;transform-origin:top left;overflow:hidden;"], props => props.width, props => props.height);

/**
 * Container that makes sure that its contents are completely visible. Keeps the width x height aspect ratio.
 */
export const PopupAutoScaleContainer = ({
  width,
  height,
  staticBorderX,
  staticBorderY,
  percentageBorderX,
  percentageBorderY,
  children
}) => {
  const [containerElement, setContainerElement] = useState(null);
  const [outerContainerElement, setOuterContainerElement] = useState(null);
  useEffect(() => {
    if (!containerElement || !outerContainerElement) return undefined;

    const onResize = () => {
      const browserWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      const browserHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
      const availableWidth = (browserWidth - staticBorderX) * (1 - percentageBorderX);
      const availableHeight = (browserHeight - staticBorderY) * (1 - percentageBorderY);
      const scale = Math.min(availableWidth / width, availableHeight / height);
      containerElement.setAttribute("style", "transform: scale(" + scale + ")");
      outerContainerElement.setAttribute("style", `width: ${width * scale}px; height: ${height * scale}px;`);
    };

    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [containerElement, outerContainerElement, width, height, staticBorderX, staticBorderY, percentageBorderX, percentageBorderY]);
  return /*#__PURE__*/React.createElement(OuterContainer, {
    ref: setOuterContainerElement
  }, /*#__PURE__*/React.createElement(InnerContainer, {
    width: width,
    height: height,
    ref: setContainerElement
  }, children));
};